<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">payments</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">{{ lancou ? 'Financeiro lançado' : 'Lançar financeiro' }}</h2>
        <span class="modal-subtitle">{{ data.rotuloDocumento }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content scroll-suave">
    @if (isLoading) {
        <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
    } @else if (resultado) {
        <!-- Depois do lançamento: só os boletos e os links Pix a copiar; o retorno foi pelo toast. -->
        @if (resultado.boletosGerados; as boletos) {
            <div class="nfelf-bloco">
                <div class="nfelf-bloco-titulo">Boletos</div>
                <ul class="nfelf-lista-simples">
                    <li>{{ boletos.sucesso }} boleto(s) gerado(s).</li>
                    @if (boletos.semIntegracao > 0) {
                        <li class="nfelf-aviso">{{ boletos.semIntegracao }} boleto(s) não gerado(s): conta sem integração bancária.</li>
                    }
                    @if (boletos.falha > 0) {
                        <li class="nfelf-aviso">{{ boletos.falha }} boleto(s) com falha na emissão: reemita pelo contas a receber.</li>
                    }
                    @for (mensagem of boletos.mensagens; track $index) {
                        <li class="nfelf-mensagem">{{ mensagem }}</li>
                    }
                </ul>
            </div>
        }

        @if (resultado.linksCobranca.length) {
            <div class="nfelf-bloco">
                <div class="nfelf-bloco-titulo">Links de cobrança Pix</div>
                @for (link of resultado.linksCobranca; track link.idContasReceberParcela) {
                    <div class="nfelf-link">
                        <span class="nfelf-link-parcela">Parcela {{ link.nroParcela }}</span>
                        <span class="nfelf-link-url" [matTooltip]="linkCobranca(link.guidAcessoCobranca)">{{ linkCobranca(link.guidAcessoCobranca) }}</span>
                        <button mat-icon-button type="button" class="nfelf-link-copiar" matTooltip="Copiar link." aria-label="Copiar link"
                            (click)="copiarLink(link.guidAcessoCobranca)">
                            <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
                        </button>
                    </div>
                }
            </div>
        }
    } @else if (!temItens) {
        <app-alert-card type="warning" title="Nota sem recebimentos">
            A nota não tem recebimentos: sem recebimento não há financeiro a lançar.
        </app-alert-card>
    } @else {
        <p class="descricao-modal">
            Cada recebimento vira um registro no Finanças, conforme a forma e a conta: entrada direta em conta
            caixa ou bancária (uma por parcela), ou título de contas a receber com as parcelas da nota. Com
            intermediador, o vencimento segue o prazo dele e a taxa e a tarifa ficam previstas no título. Para
            desfazer, exclua o financeiro pelo menu Ações da nota.
        </p>

        @if (mensagemDiferencaTotal) {
            <app-alert-card type="warning" title="Recebimentos diferentes do total">{{ mensagemDiferencaTotal }}</app-alert-card>
        }

        @for (item of itens; track item.sequencia) {
            <div class="nfelf-item">
                <div class="nfelf-item-cabecalho">
                    <mat-icon class="material-symbols-outlined nfelf-item-icone">{{ item.ehMovimentacao ? 'account_balance_wallet' : 'receipt_long' }}</mat-icon>
                    <div class="nfelf-item-titulos">
                        <span class="nfelf-item-forma">{{ item.sequencia }}. {{ item.forma }}</span>
                        <span class="nfelf-item-detalhe">Categoria: {{ item.categoria }}@if (item.conta) { · Conta: {{ item.conta }}}</span>
                    </div>
                    <span class="nfelf-item-valor">{{ item.valor | abnt:'preco':2 }}</span>
                </div>

                @if (item.erro) {
                    <app-alert-card type="warning">{{ item.erro }}</app-alert-card>
                } @else if (item.ehMovimentacao) {
                    <div class="nfelf-item-efeito">
                        @if (item.entradas.length > 1) {
                            {{ item.entradas.length }} movimentações de entrada na conta {{ item.conta }}, uma por parcela, no vencimento de cada uma.
                        } @else {
                            Movimentação de entrada na conta {{ item.conta }} na data de emissão da nota.
                        }
                    </div>
                    @if (item.entradas.length > 1) {
                        <table class="nfelf-parcelas">
                            @for (entrada of item.entradas; track $index) {
                                <tr>
                                    <td>{{ $index + 1 }}/{{ item.entradas.length }}</td>
                                    <td>{{ entrada.data | diaCivil }}</td>
                                    <td class="nfelf-parcela-valor">{{ entrada.valor | abnt:'preco':2 }}</td>
                                </tr>
                            }
                        </table>
                    }
                } @else {
                    <div class="nfelf-item-efeito">
                        Título com {{ item.parcelas.length }} parcela(s)@if (!item.conta) { - sem conta (crediário)}@if (item.intermediador) { · pelo intermediador {{ item.intermediador }}@if (item.taxaPercentual != null) { (taxa {{ item.taxaPercentual | abnt:'quantidade':2 }}%)}}@if (item.ehBoleto) { · boleto}@if (item.ehPix) { · Pix com link de cobrança}
                    </div>
                    @if (item.parcelas.length) {
                        <table class="nfelf-parcelas">
                            @if (temTaxa(item) || temJuros(item)) {
                                <tr class="nfelf-parcelas-cabecalho">
                                    <th scope="col"></th>
                                    <th scope="col">Vencimento</th>
                                    <th scope="col" class="nfelf-parcela-valor">Valor</th>
                                    @if (temTaxa(item)) { <th scope="col" class="nfelf-parcela-valor">Taxa</th> }
                                    @if (temTarifaRateada(item)) { <th scope="col" class="nfelf-parcela-valor">Tarifa</th> }
                                    @if (temTaxa(item)) { <th scope="col" class="nfelf-parcela-valor">Líquido</th> }
                                    @if (temJuros(item)) { <th scope="col" class="nfelf-parcela-valor">Juros</th> }
                                </tr>
                            }
                            @for (parcela of item.parcelas; track parcela.numero) {
                                <tr>
                                    <td>{{ parcela.numero }}/{{ item.parcelas.length }}</td>
                                    <td>{{ parcela.vencimento | diaCivil }}</td>
                                    <td class="nfelf-parcela-valor">{{ parcela.valor | abnt:'preco':2 }}</td>
                                    @if (temTaxa(item)) { <td class="nfelf-parcela-valor">{{ parcela.taxa | abnt:'preco':2 }}</td> }
                                    @if (temTarifaRateada(item)) { <td class="nfelf-parcela-valor">{{ parcela.tarifa | abnt:'preco':2 }}</td> }
                                    @if (temTaxa(item)) { <td class="nfelf-parcela-valor">{{ parcela.liquido | abnt:'preco':2 }}</td> }
                                    @if (temJuros(item)) { <td class="nfelf-parcela-valor">{{ parcela.juros | abnt:'preco':2 }}</td> }
                                </tr>
                            }
                        </table>
                    }
                    @if (item.tarifaSeparada; as tarifa) {
                        <div class="nfelf-item-efeito">
                            <mat-icon class="material-symbols-outlined nfelf-tarifa-icone">payments</mat-icon>
                            Tarifa do intermediador de {{ tarifa.valor | abnt:'preco':2 }}: saída na conta {{ tarifa.conta }} em {{ tarifa.data | diaCivil }}.
                        </div>
                    }
                    @if (temJuros(item)) {
                        <div class="nfelf-item-efeito">Juros da condição previstos nas parcelas: {{ item.totalJuros | abnt:'preco':2 }}. A nota não muda.</div>
                    }
                }
            </div>
        }

        <div class="nfelf-total">
            <span>Total dos recebimentos</span>
            <strong>{{ totalRecebimentos | abnt:'preco':2 }}</strong>
        </div>

        @if (temBoleto) {
            <!-- Mesmo texto do cadastro do contas a receber (contas-receber-cadastro, "Gerar boletos?"). -->
            <div class="nfelf-boleto">
                <mat-checkbox color="primary" [(ngModel)]="gerarBoletos">Gerar os boletos das parcelas agora</mat-checkbox>
                <div class="nfelf-boleto-custo">
                    Custo de bilhetagem: <strong>{{ custoBoletoUnitario | abnt:'preco':2 }}</strong> por boleto -
                    total <strong>{{ custoBoletoTotal | abnt:'preco':2 }}</strong> ({{ qtdParcelasBoleto }} parcela(s)).
                    Conta sem integração bancária não gera boleto; o título é criado mesmo assim.
                </div>
            </div>
        }
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    @if (lancou || (!isLoading && !temItens)) {
        <button mat-flat-button type="button" class="btn-primary" (click)="fechar()">Fechar</button>
    } @else {
        <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isLancando" (click)="fechar()">Cancelar</button>
        <!-- Com erro em algum recebimento ou recebimentos diferentes do total o orquestrador recusaria: não lança. -->
        <span [matTooltip]="tooltipLancar" [matTooltipDisabled]="!tooltipLancar">
            <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isLancando"
                [disabled]="isLoading || isLancando || temErro || !!mensagemDiferencaTotal" [attr.aria-label]="isLancando ? 'Lançando financeiro' : 'Lançar financeiro'"
                (click)="confirmar()">
                <mat-icon class="material-symbols-outlined">check</mat-icon>
                Lançar financeiro
                @if (isLancando) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
        </span>
    }
</mat-dialog-actions>
